import axios, { AxiosInstance, AxiosError, InternalAxiosRequestConfig } from 'axios';

// Create axios instance with base configuration
const api: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3001/api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - Add auth token to requests
api.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = localStorage.getItem('authToken');
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

// Response interceptor - Handle errors globally
api.interceptors.response.use(
  (response: any) => {
    return response;
  },
  (error: AxiosError) => {
    if (error.response) {
      // Server responded with error status
      const status = error.response.status;
      const data: any = error.response.data;

      switch (status) {
        case 401:
          // Unauthorized - clear token and redirect to login
          localStorage.removeItem('authToken');
          localStorage.removeItem('user');
          if (window.location.pathname !== '/login') {
            window.location.href = '/login';
          }
          break;
        case 403:
          // Forbidden
          console.error('Access forbidden:', data.error || data.message);
          break;
        case 404:
          // Not found
          console.error('Resource not found:', data.error || data.message);
          break;
        case 409:
          // Conflict (e.g., user already exists)
          console.error('Conflict:', data.error || data.message);
          break;
        case 422:
          // Validation error
          console.error('Validation error:', data.errors || data.error);
          break;
        case 500:
        case 502:
        case 503:
          // Server errors
          console.error('Server error:', data.error || data.message || 'Something went wrong');
          break;
        default:
          console.error('API error:', data.error || data.message || 'An error occurred');
      }

      // Return formatted error
      return Promise.reject({
        status,
        message: data.error || data.message || 'An error occurred',
        errors: data.errors,
      });
    } else if (error.request) {
      // Request made but no response received
      console.error('Network error: No response from server');
      return Promise.reject({
        status: 0,
        message: 'Network error. Please check your connection.',
      });
    } else {
      // Error in request setup
      console.error('Request error:', error.message);
      return Promise.reject({
        status: 0,
        message: error.message || 'An error occurred',
      });
    }
  }
);

export default api;
